import VueGtag from 'vue-gtag-next';

export default {
    install(app, router) {
        const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID;

        if (!measurementId) {
            console.warn('Google Analytics measurement ID not found in environment variables');
            return;
        }

        app.use(VueGtag, {
            property: {
                id: measurementId
            },
            appName: import.meta.env.VITE_APP_NAME || 'Windorchestra',
            pageTrackerScreenviewEnabled: true,
            router
        });
    }
};
